class CartWatcher {
  init() {
    console.log('CartWatcher init');
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

  storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    // const oldCart = this.storedCart();
    // const changes = this.findCartChanges(oldCart, newCart);

    // const event = new CustomEvent('cart_changed', { detail: changes });
    const totalPriceEvent = new CustomEvent('cart_total_price', { detail: newCart.total_price });

    // window.dispatchEvent(event);
    window.dispatchEvent(totalPriceEvent);

    this.updateShippingGift(newCart);
    this.storeCart(newCart);
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ['resource'] });
  }

  updateShippingGift(cart) {
    const itemCount = cart.item_count;
    let freeItemCount = 0;

    cart.items.forEach((item) => {
      if (item.line_price === 0) {
        freeItemCount += item.quantity;
      }
    });

    const freeStrapsCount = parseInt((itemCount - 3 * freeItemCount) / 2);

    if (itemCount > 0) {
      this.hideShippingGift();

      if (this.shouldShowAddOneMoreStrap(itemCount, freeItemCount)) {
        this.showShippingGift(
          "Add 1 More Strap To Cart & Get A Free Nylon Strap <a style='color:#e6e6e6 !important; font-size:10px;' href='https://www.wabistraps.com/collections/free-nylon-strap'>Continue Shopping >></a>"
        );
      }

      if (this.shouldShowQualifyForFreeStraps(itemCount, freeItemCount)) {
        this.showShippingGift(
          `Hurray! You Qualify For ${freeStrapsCount} Free Nylon Strap(s) <a class='ship_gl' href='https://www.wabistraps.com/collections/free-nylon-strap'>Click Here To Choose Your Favourite Design >></a>`
        );
      }

      if (this.shouldShowAddTwoMoreStraps(itemCount, freeItemCount)) {
        this.showShippingGift(
          "Add 2 More Straps To Cart & Get A Free Nylon Strap <a style='color:#e6e6e6 !important; font-size:10px;' href='https://www.wabistraps.com/collections/free-nylon-strap'>Continue Shopping >></a>"
        );
      }
    }
  }

  shouldShowAddOneMoreStrap(itemCount, freeItemCount) {
    return itemCount === 1 || (itemCount > 3 && itemCount - 3 * freeItemCount === 1);
  }

  shouldShowQualifyForFreeStraps(itemCount, freeItemCount) {
    return (
      itemCount === 2 ||
      (itemCount > 3 && itemCount - 3 * freeItemCount > 1) ||
      (itemCount === 3 && freeItemCount === 0)
    );
  }

  shouldShowAddTwoMoreStraps(itemCount, freeItemCount) {
    return (itemCount === 3 && freeItemCount === 1) || (itemCount > 3 && itemCount - 3 * freeItemCount === 0);
  }

  showShippingGift(message) {
    const shippingGiftElements = document.querySelectorAll('.Shipping_Gift');
    console.log('shippingGiftElements', shippingGiftElements);
    if (shippingGiftElements.length > 0) {
      shippingGiftElements.forEach((element) => {
        element.style.display = 'block';
        const spanElement = element.querySelector('span');
        if (spanElement) {
          spanElement.innerHTML = message;
        }
      });
    }
  }

  hideShippingGift() {
    const shippingGiftElements = document.querySelectorAll('.Shipping_Gift');
    if (shippingGiftElements.length > 0) {
      shippingGiftElements.forEach((element) => {
        element.style.display = 'none';
      });
    }
  }
}
